import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "./basicProfile.css";
import {
  TextInputField,
  TextInput,
  Select,
  option,
  FilePicker,
} from "evergreen-ui";
import SaveBTN from "./SaveBtn/SaveBTN";
import { useNavigate } from "react-router-dom";
import SubmitButton from "../../Buttons/SubmitButton/SubmitButton";

const AssociatedFile = ({
  allData,
  setAllData,
  handleProfileUpdate,
  doc,
  loading,
}) => {
  const navigate = useNavigate();
  const [validFiles, setvalidFiles] = useState([
    "image/jpg",
    "image/jpeg",
    "image/png",
  ]);
  const [validFilesPdf, setvalidFilesPdf] = useState([
    "application/pdf",
    "image/jpg",
    "image/jpeg",
    "image/png",
  ]);
  const [allfiles, setallfiles] = useState([
    {
      unique: "tradeLicense",
      path: "",
      url: "",
      name: "",
      file_size: "",
      file_type: "",
    },
    {
      unique: "taxReg",
      path: "",
      url: "",
      name: "",
      file_size: "",
      file_type: "",
    },
    {
      unique: "vendorLogo",
      path: "",
      url: "",
      name: "",
      file_size: "",
      file_type: "",
    },
  ]);
  const [switchEdit, setswitchEdit] = useState(false);

  const [getAllData, setgetAllData] = useState(allData);

  const handleUpload = (event, unique) => {
    const formData = new FormData();
    formData.append("file", event[0]);

    fetch(process.env.REACT_APP_API_URL + "/api/FileUpload", {
      method: "POST",
      body: formData,
    })
      .then((d) => d.json())
      .then((res) => {
        if (unique == "tradeLicense") {
          if (!validFilesPdf.includes(res.type)) {
            toast.error("please upload supported file type for Trade License");
            return;
          }
        }
        if (unique == "taxReg") {
          if (!validFilesPdf.includes(res.type)) {
            toast.error(
              "please upload supported file type for Trade Registration"
            );
            return;
          }
        }
        if (unique == "vendorLogo") {
          if (!validFiles.includes(res.type)) {
            toast.error("please upload supported file type for Vendor Logo");
            return;
          }
        }
        const narr = [...allfiles].filter((e) => e.unique != unique);
        const existingDoc = JSON.parse(
          localStorage.getItem("profile_documents")
        );
        const newAr =
          existingDoc && existingDoc.filter((e) => e.unique == unique);
        console.log(newAr);

        narr.push({
          document_id: newAr.length ? newAr[0].document_id : "",
          unique,
          path: res.path,
          url: res.url,
          name: res.name,
          file_size: res.size,
          file_type: res.type,
        });
        setallfiles(narr);
      });
  };

  const handleBasicProfile = () => {
    setAllData({
      ...allData,
      documents: allfiles,
    });
  };

  const saveHandler = () => {
    handleProfileUpdate();
    setswitchEdit(false);
  };

  useEffect(() => {
    handleBasicProfile();
  }, [allfiles]);

  const handleDownload = (urls) => {
    if (urls) {
      const urlss = urls;
      const link = document.createElement("a");
      link.href = urlss;
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    }
  };

  return (
    <div className="basicProfileMainContainer">
      <div className="basicProfileFirtRow">
        <div className="basicProfileMainContainerHead">
          <div>
            <img src="./images/stratum/associateFileDetails.svg" alt="" />
          </div>
          <div className="basicdetailName">Associated Files</div>
        </div>
        {!switchEdit ? (
          <div
            className="editInPf"
            onClick={() => {
              setswitchEdit(true);
            }}
          >
            <img src="./images/stratum/edit.svg" alt="" />
          </div>
        ) : (
          <div
            className="editInPf"
            onClick={() => {
              setswitchEdit(false);
            }}
          >
            <img src="./images/stratum/closeLogo.svg" alt="" />
          </div>
        )}
      </div>
      <div className="detailsColumInProfile">
        <div>
          <p className="subHeadProfileTab"> TRADE LICENSE</p>
          {!switchEdit ? (
            <div className="inputDesabledDta">
              <p>
                {doc.length
                  ? doc.filter((x) => x.unique == "tradeLicense")[0]?.orig_name
                  : "-"}
              </p>
              {doc.filter((x) => x.unique == "tradeLicense").length > 0 && (
                <div
                  className="editInPf"
                  onClick={(e) => {
                    let newUrl = doc.filter((x) => x.unique == "tradeLicense");
                    handleDownload(newUrl.length && newUrl[0].url);
                  }}
                >
                  <img src="./images/stratum/download.svg" alt="" />
                </div>
              )}
            </div>
          ) : (
            <FilePicker
              multiple={false}
              width={279}
              height={32}
              placeholder="Browse..."
              accept=".pdf, .jpg, .png, .jpeg"
              onChange={(e) => handleUpload(e, "tradeLicense")}
            />
          )}
        </div>
        <div>
          {" "}
          <p className="subHeadProfileTab">TAX REGISTRATION CERTIFICATE</p>
          {!switchEdit ? (
            <div className="inputDesabledDta">
              <p>
                {doc.length
                  ? doc.filter((x) => x.unique == "taxReg")[0]?.orig_name
                  : "-"}
              </p>
              {doc.filter((e) => e.unique == "taxReg").length > 0 && (
                <div
                  className="editInPf"
                  onClick={() => {
                    let newUrl = doc.filter((e) => e.unique == "taxReg");

                    handleDownload(newUrl.length && newUrl[0].url);
                  }}
                >
                  <img src="./images/stratum/download.svg" alt="" />
                </div>
              )}
            </div>
          ) : (
            <FilePicker
              multiple={false}
              width={279}
              height={32}
              placeholder="Browse..."
              onChange={(e) => handleUpload(e, "taxReg")}
              accept=".pdf, .jpg, .png, .jpeg"
            />
          )}
        </div>
        <div>
          {" "}
          <p className="subHeadProfileTab">VENDOR LOGO</p>
          {!switchEdit ? (
            <div className="inputDesabledDta">
              <p>
                {doc.length
                  ? doc.filter((x) => x.unique == "vendorLogo")[0]?.orig_name
                  : "-"}
              </p>
              {doc.filter((e) => e.unique == "vendorLogo").length > 0 && (
                <div
                  className="editInPf"
                  onClick={() => {
                    let newUrl = doc.filter((e) => e.unique == "vendorLogo");
                    handleDownload(newUrl?.length && newUrl[0]?.url);
                  }}
                >
                  <img src="./images/stratum/download.svg" alt="" />
                </div>
              )}
            </div>
          ) : (
            <FilePicker
              multiple={false}
              width={279}
              height={32}
              placeholder="Browse..."
              onChange={(e) => handleUpload(e, "vendorLogo")}
              accept=".jpg,.png,.jpeg"
            />
          )}
        </div>
      </div>
      {switchEdit && (
        <div className="btnmarginPf">
          {/* <SaveBTN handlesave={saveHandler} /> */}
          <SubmitButton
            ApplyFunction={saveHandler}
            text={"Save Changes"}
            loading={loading}
          />
        </div>
      )}
      {/* <ToastContainer autoClose={false} /> */}
    </div>
  );
};

export default AssociatedFile;
